import React from 'react'

import CmsPage from 'components/CmsPage/CmsPage'
import EnrollForm from 'components/EnrollForm/EnrollForm'
import Spinner from 'components/Spinner/Spinner'
import Wrapper from 'components/Wrapper/Wrapper'
import usePage from 'hooks/usePage'

const EnrollPage = (): JSX.Element => {
  const { page, loading } = usePage('enroll')

  if (loading) {
    return <Spinner height={30} centered />
  }

  return (
    <>
      {page?.publicCmsItems ? (
        <CmsPage slug="enroll" wrapItems />
      ) : (
        <Wrapper>
          <EnrollForm showFull />
        </Wrapper>
      )}
    </>
  )
}

export default EnrollPage
